import { render, staticRenderFns } from "./NewDocumentsPage.vue?vue&type=template&id=f07fb826&scoped=true&"
import script from "./NewDocumentsPage.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentsPage.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentsPage.vue?vue&type=style&index=0&id=f07fb826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07fb826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSimpleCheckbox,VTooltip})
